<div class="dashboard-content">
  <header class="dashboard-header">
  <div class="dashboard-title">
    <mat-icon aria-hidden="true" focusable="false">timeline</mat-icon>
    <div class="dashboard-title-text">{{ 'Dashboard.TrendTitle' | translate: { days: selectedTimeWindow } }}</div>
  </div>
  <div class="dashboard-controls">
     <mat-form-field appearance="outline" class="dashboard-select" subscriptSizing="dynamic">
      <mat-label>{{ 'Dashboard.TimeWindowLabel' | translate }}</mat-label>
      <mat-select
        [value]="selectedTimeWindow"
        (selectionChange)="selectTimeWindow($event.value)">
        @for (option of timeWindowOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.labelKey | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="dashboard-select" subscriptSizing="dynamic">
      <mat-label>{{ 'Dashboard.GeographyLabel' | translate }}</mat-label>
      <mat-select
        [value]="selectedGeography"
        (selectionChange)="selectGeography($event.value)">
        @for (option of geographyOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.labelKey | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  </header>
  <div class="dashboard-chart-frame">
    <div
      #chart
      class="dashboard-chart"
      role="img"
      [attr.aria-label]="'Dashboard.ChartAccessibleName' | translate">
    </div>
  </div>
</div>
